import React, { } from 'react';
import { Card, Col, Row, } from 'antd';

import eatAllDonuts from '../myContent/EatAllDonuts.png';

import '../App.css';




const ItchGamesPage: React.FC = () => {


    return (
        <div className="App">
            <header className="App-header">

                <a
                    className="App-link"
                    href="/"
                    rel="noopener noreferrer">
                    Go back
                </a>

                This is my Itch.io games page!

                <Card className='width395 marginBig' >
                    <Row>
                        <Col span={24}>
                            <a
                                className="App-link"
                                href="https://smileyfist.itch.io/eat-all-donuts"
                                target="_blank"
                                rel="noopener noreferrer">
                                Eat all Donuts
                            </a>
                        </Col>
                        <Col span={24}>
                            <img src={eatAllDonuts} alt="eatAllDonuts" className='width160' />

                        </Col>
                    </Row>
                </Card>


            </header>
        </div>
    );
}

export default ItchGamesPage;
